import queryString from 'query-string';
const domains = require('../../../env/index.js')
// publicted 是否需要鉴权
// replay是否需要重新发送请求

/**
 * @description 通过key 获取域名
 * @param key 域名
 * @returns
 */
export const getConfig = async (key) => {
  // if (!key) {
  //   console.warn(`域名键 ${key} 不存在于 env/index.js 中,请检查配置文件`);
  // }
  // if (!Object.keys(domains).includes(key)) {
  //   console.warn(`域名键 ${key} 不是有效的配置项`);
  // }
  return domains[key]
}

/**
 * @description 处理请求地址
 * @param baseURL 基础地址,比如 域名
 * @param requestUrl 具体的api地址
 * @returns
 */
export const urlResolve = (baseURL, requestUrl = "") => {
  if (requestUrl.startsWith("http")) {
    return requestUrl;
  }
  if (requestUrl.startsWith("/")) {
    return new URL(baseURL).origin + requestUrl;
  }
  return baseURL + requestUrl;
};
/**
 * @description axios options.params 序列化
 * @param params options.params
 * @returns
 */

export const paramsSerializer = (params) => {
  let newParams = {}
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (typeof value === "object") {
      newParams[key] = JSON.stringify(value)
    } else {
      newParams[key] = value;
    }
  })
  return queryString.stringify(newParams);
}


export const guessErrorMsg = (data) => {
  let msg = "";
  const type = Object.prototype.toString.call(data).slice(8, -1);
  if (type === 'Object' && data.message !== undefined && data.code !== undefined) {
    return data.message;
  }
  if (type === 'Array' || type === 'Object') {
    let _temp = Array.isArray(data) ? data : Object.values(data);
    _temp = _temp.flat(Infinity);
    _temp = _temp.filter((x) => typeof x === 'string' && x).join(',');
    msg = `${_temp || ''}`.trim();
  }
  return msg;
}